import { Pipe, PipeTransform } from "@angular/core";
import { UserJSON } from "../../models/json/userJSON";
import { User } from "../../models/user.model";

@Pipe({
    name: "fullName",
})
export class FullNamePipe implements PipeTransform {
    transform(user: UserJSON | User): string {
        if (user != null) {
            const nameParts = [user.firstname, user.middlename, user.lastname];
            return nameParts.filter((x) => x && x.length > 0).join(" ");
        }
        return "";
    }
}
